import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API_BASE_URL from '../config';
import SEO from '../components/SEO';

function SignIn() {
  var [isLogin, setIsLogin] = useState(true);
  var [email, setEmail] = useState('');
  var [password, setPassword] = useState('');
  var [name, setName] = useState('');
  var [error, setError] = useState('');
  var [loading, setLoading] = useState(false);
  var navigate = useNavigate();

  // Already signed in → redirect to dashboard
  useEffect(function() {
    var token = localStorage.getItem('agent_token');
    if (!token) return;
    fetch(API_BASE_URL + '/api/projects', {
      headers: { Authorization: 'Bearer ' + token },
    }).then(function(r) { return r.json(); })
      .then(function(d) {
        if (d.projects && d.projects.length > 0) navigate('/agent/dashboard/' + d.projects[0].id, { replace: true });
        else navigate('/agent/onboarding', { replace: true });
      }).catch(function() {});
  }, [navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    var endpoint = isLogin ? '/api/auth/login' : '/api/auth/signup';
    var body = isLogin ? { email, password } : { email, password, name };
    try {
      var res = await fetch(API_BASE_URL + endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      var data = await res.json();
      if (!res.ok) { setError(data.error || 'Something went wrong'); setLoading(false); return; }
      localStorage.setItem('agent_token', data.token);
      localStorage.setItem('agent_user', JSON.stringify(data.user));
      var projRes = await fetch(API_BASE_URL + '/api/projects', { headers: { Authorization: 'Bearer ' + data.token } });
      var projData = await projRes.json();
      if (projData.projects && projData.projects.length > 0) navigate('/agent/dashboard/' + projData.projects[0].id);
      else navigate('/agent/onboarding');
    } catch (err) {
      setError('Network error');
    }
    setLoading(false);
  }

  return (
    <div className="signin-page">
      <SEO title={isLogin ? 'Sign In — Anthroper' : 'Create Account — Anthroper'} description="Sign in to your Anthroper account." path="/signin" />
      <div className="signin-card">
        <Link to="/" className="signin-back">← Back to site</Link>
        <div className="signin-logo">A</div>
        <h1 className="signin-title">{isLogin ? 'Welcome back' : 'Create your account'}</h1>
        <p className="signin-sub">{isLogin ? 'Sign in to access your Marketing Agent dashboard.' : 'Get started with your AI marketing assistant.'}</p>

        <form onSubmit={handleSubmit} className="signin-form">
          {!isLogin && (
            <div className="signin-field">
              <label className="signin-label">Name</label>
              <input type="text" placeholder="Your name" value={name} onChange={function(e) { setName(e.target.value); }} className="signin-input" />
            </div>
          )}
          <div className="signin-field">
            <label className="signin-label">Email</label>
            <input type="email" placeholder="you@example.com" value={email} required onChange={function(e) { setEmail(e.target.value); }} className="signin-input" />
          </div>
          <div className="signin-field">
            <label className="signin-label">Password</label>
            <input type="password" placeholder="••••••••" value={password} required minLength={6} onChange={function(e) { setPassword(e.target.value); }} className="signin-input" />
          </div>
          {error && <p className="signin-error">{error}</p>}
          <button type="submit" className="btn btn-primary btn-lg signin-submit" disabled={loading}>
            {loading ? 'Please wait…' : isLogin ? 'Sign In' : 'Create Account'}
          </button>
        </form>

        <p className="signin-toggle">
          {isLogin ? "Don't have an account? " : 'Already have an account? '}
          <button type="button" className="signin-link-btn" onClick={function() { setIsLogin(!isLogin); setError(''); }}>
            {isLogin ? 'Sign Up' : 'Sign In'}
          </button>
        </p>
      </div>
    </div>
  );
}

export default SignIn;
